import { Icon, IconProps } from './Icon';

export const IconArrowDown = (props: IconProps) => (
  <Icon {...props}>
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="32"
      d="M69 163l187 187 187-187"
    />
  </Icon>
);
